/**
 * 高企认定 报告管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>报告管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.company_name" style="width:140px" placeholder="输入企业名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.industry_name" style="width:140px" placeholder="输入行业名称"></el-input>
      </el-form-item>
       <el-form-item>
        <el-input size="small" v-model="formInline.lowest_score" style="width:140px" placeholder="输入最低得分"></el-input>
      </el-form-item>
       <el-form-item>
        <el-input size="small" v-model="formInline.hightest_score" style="width:140px" placeholder="输入最高得分"></el-input>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择测评开始时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择测评结束时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="danger" icon="el-icon-delete" @click="delCheck" title="将删除所有勾选的数据">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="company_name" align="center" label="企业名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="establish_time" align="center" label="成立时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="industry_name" align="center" label="所属行业" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="staff_num" align="center" label="员工总数(人)" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="education_num" align="center" label="大专及以上(人)" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="technology_num" align="center" label="研发创新数(人)" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="kjcg_score" align="center" label="科技成果，转化能力得分" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="zscq_score" align="center" label="知识产权得分" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="yjkf_score" align="center" label="研开管理得分" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="qycz_score" align="center" label="企业成长性得分" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="total_score" align="center" label="总分" width="60px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="测评时间" width="140px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="isArtificial" align="center" label="是否需要人工测评" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="name" align="center" label="联系人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="tel" align="center" label="联系电话" width="110px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
          <el-button size="mini" type="danger" @click="delMonitor(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="140" :model="infoForm" ref="infoForm">      
        <el-row>
          <el-col :span="12">
            <div>
              <h3>基本情况</h3>
                企业名称:<input class="reportInfo" v-model="infoForm.company_name" disabled /><br/>
                成立时间:<input class="reportInfo" v-model="infoForm.establish_time" disabled /><br/>
                所属行业:<input class="reportInfo" v-model="infoForm.industry_name" disabled /><br/>
          </div>
          <div>
              <h3>知识产权情况</h3>
                1.I类数量: <input class="reportInfoAdapt" v-model="infoForm.examOne" disabled /> (项),II类数量 <input class="reportInfoAdapt" v-model="infoForm.examTwo" disabled /> (项)<br/>
                注:I类指发明专利，植物新品种，国家新药，国家级农作物品种，集成电路图等； II类是指实用新型专利，外观设计专利，软件著作权。<br/>
                2.知识产权获得方式：<input class="reportInfo" v-model="infoForm.examThree" disabled /><br/>
                A:自主研发<br/>
                B:仅有受让、受赠和并购等<br/>
                3.是否参与国家标准或技术规范等制定：<input class="reportInfo" v-model="infoForm.examFour" disabled /><br/>
                A:是<br/>
                B:否<br/>
          </div>
          <div>
              <h3>研究开发与组织管理水平</h3>
                6.是否建立了内部研发机构：<input class="reportInfo" v-model="infoForm.examSeven" disabled /><br/>
                A:是<br/>
                B:否<br/>
                7.是否建立了研发费用转账或辅助账：<input class="reportInfo" v-model="infoForm.examEight" disabled /><br/>
                A:是<br/>
                B:否<br/>
                8.是否签订产学研合作协议：<input class="reportInfo" v-model="infoForm.examNine" disabled /><br/>
                A:是<br/>
                B:否<br/>
          </div>
          <div>
              <h3>评估结果</h3>
               最终得分:<input class="reportInfo" v-model="infoFormEx.total_score" disabled /><br/>
               知识产权得分:<input class="reportInfo" v-model="infoFormEx.zscq_score" disabled /><br/>
               科技成果转化能力得分:<input class="reportInfo" v-model="infoFormEx.kjcg_score" disabled /><br/>
               研究开发组织管理水平得分:<input class="reportInfo" v-model="infoFormEx.yjkf_score" disabled /><br/>
               企业成长性得分:<input class="reportInfo" v-model="infoFormEx.qycz_score" disabled /><br/>
          </div>
          </el-col>
          <el-col :span="12">
            <div>
              <h3>人员情况</h3>
                员工总数（人）:<input class="reportInfo" v-model="infoForm.staff_num" disabled /><br/>
                大专及以上人数（人）:<input class="reportInfo" v-model="infoForm.education_num" disabled /><br/>
                从事研发和相关技术创新活动科技人员数量（人）:<input class="reportInfoAdapt" v-model="infoForm.technology_num" disabled /><br/>
            </div>
             <div>
              <h3>科技成果转化情况</h3>
               4.近三年拥有成果数量: <input class="reportInfoAdapt" v-model="infoForm.examFive" disabled />（项）<br/>
               注:有效期内的I类、II类知识产权；参与制定的国家、行业、地方标准或技术规范等；各级政府、行业协会、第三方权威机构出具的科技成果评价；已验收的各级政府部门立项的科研类项目；经登记的技术交易合同、知识产权许可合同；经认定的科技成果转化项目（注：查新报告、检测报告、销售发票、论文等不可作为科技成果）。<br/>
               5.企业成立年限（自然年）<input class="reportInfo" v-model="infoForm.examSix" disabled /><br/>
               A:1年<br/>
               B:2年<br/>
               C:3年及以上<br/>
            </div>
            <div>
              <h3>近三年经营情况</h3>
                <table>
                    <tr>
                       <th>年度（单位：万元）</th>
                       <th>申报前三年</th>
                       <th>申报前两年</th>
                       <th>申报前一年</th>
                    </tr>
                    <tr>
                        <th>销售收入</th>
                        <th><input class="reportInfoAdapt" v-model="infoForm.threeYearSale" disabled /></th>
                        <th><input class="reportInfoAdapt" v-model="infoForm.twoYearSale" disabled /></th>
                        <th><input class="reportInfoAdapt" v-model="infoForm.oneYearSale" disabled /></th>
                    </tr>
                    <tr>
                        <th>净资产</th>
                        <th><input class="reportInfoAdapt" v-model="infoForm.threeYearAssets" disabled /></th>
                        <th><input class="reportInfoAdapt" v-model="infoForm.twoYearAssets" disabled /></th>
                        <th><input class="reportInfoAdapt" v-model="infoForm.oneYearAssets" disabled /></th>
                    </tr>
                    <tr>
                        <th>研发费用</th>
                        <th><input class="reportInfoAdapt" v-model="infoForm.threeYearDev" disabled /></th>
                        <th><input class="reportInfoAdapt" v-model="infoForm.twoYearDev" disabled /></th>
                        <th><input class="reportInfoAdapt" v-model="infoForm.oneYearDev" disabled /></th>
                    </tr>
                </table>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { gqchatReportList, gqchatReportInfo, gqchatUrl, gqchatReportDel, gqchatReportDelCheck } from '../../api/wechatMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '查看报告',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      infoForm: {
        company_name: '',
        education_num: '',
        establish_time: '',
        examEight: '',
        examFive: '',
        examFour: '',
        examNine: '',
        examOne: '',
        examSeven: '',
        examSix: '',
        examThree: '',
        examTwo: '',
        oneYearAssets: '',
        oneYearDev: '',
        oneYearSale: '',
        staff_num: '',
        technology_num: '',
        threeYearAssets: '',
        threeYearDev: '',
        threeYearSale: '',
        twoYearAssets: '',
        twoYearDev: '',
        twoYearSale: '',
        token: localStorage.getItem('logintoken')
      },
      infoFormEx: {
        total_score: 0,
        yjkf_score: 0,
        zscq_score: 0,
        qycz_score: 0,
      },
       formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        company_name: '',
        industry_name: '',
        lowest_score: '',
        hightest_score: '',
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      gqchatReportList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //导出excel
    exportCheck() {
      //判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定导出勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        
        const idStr = JSON.stringify(idsArr)
        console.log(idStr)
        // console.log(data)
        window.location.href = gqchatUrl + "/admin/export/exportReportCheck?ids=" + idStr
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    exportAll() {
      this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
          window.location.href = gqchatUrl + "/admin/export/exportReportAll?company_name="+this.formInline.company_name+"&industry_name="+this.formInline.industry_name+"&start_time="+this.formInline.start_time+"&end_time="+this.formInline.end_time
          +"&lowest_score="+this.formInline.lowest_score+"&hightest_score="+this.formInline.hightest_score;
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.infoFormEx = row
      //查询报告详情
      const infoParam = {id:row.id}
      gqchatReportInfo(infoParam)
      .then(res => {
          if (res.code == 200) {
            this.editFormVisible = true
            this.infoForm = res.data.content
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
      })
      .catch(err => {
            this.loading = false
            this.$message.error('菜单加载失败，请稍后再试！')
      })      
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除监控记录
    delMonitor(index, row) {
        this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
      const delParam = {id:row.id}
      gqchatReportDel(delParam)
      .then(res=>{
        this.loading = false
        console.log(res);
        if (res.code == 200) {
            this.$message({
                type: 'success',
                message: '删除成功'
          })
            this.getdata(this.formInline)
        } else {
            this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
         // 删除勾选的记录
    delCheck() {
      //判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const idStr = JSON.stringify(idsArr)
        const delParam = {ids:idStr}
        gqchatReportDelCheck(delParam)
        .then(res=>{
          this.loading = false
          console.log(res);
          if (res.code == 200) {
              this.$message({
                  type: 'success',
                  message: '删除成功'
            })
              this.getdata(this.formInline)
          } else {
              this.$message({
                  type: 'info',
                  message: res.msg
            })
          }
        })
        })
         .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.reportInfo {
  outline:none;
  background:transparent;
  border:none;
  outline:medium;
  color:red;
  width: 200px;
}
.reportInfoAdapt {
  outline:none;
  background:transparent;
  border:none;
  outline:medium;
  color:red;
  width: 50px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/gqchat/Busireport.vue